import { Component } from "@angular/core";
import { ImageGroup, isNotNullable } from '@spartacus/core';
import { ProductImageZoomThumbnailsComponent } from "@spartacus/product/image-zoom/components";
import { BREAKPOINT, BreakpointService, ICON_TYPE } from '@spartacus/storefront';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';


@Component({
  selector: 'cx-product-image-zoom-thumbnails',
  templateUrl: 'custom-product-image-zoom-thumbnails.component.html',
  styleUrls: ['custom-product-image-zoom-thumbnails.component.scss'],
  standalone: false
})
export class CustomProductImageZoomThumbnailsComponent extends ProductImageZoomThumbnailsComponent {
  iconTypes = ICON_TYPE;
  slideSize = "100px";
  protected mainContainer = new BehaviorSubject<ImageGroup>({});
  activeIndex: Observable<number>

  selectedIndex: number;

  constructor(protected breakpointService: BreakpointService) {
    super();
  }

  ngOnInit() {
    this.subscription.add(
      this.activeThumb.subscribe((image) => {
        this.mainContainer.next(image);
      })
    );
    this.activeIndex = this.mainContainer.asObservable().pipe(
      filter(isNotNullable),
      map((container: ImageGroup) => {
        return container.zoom?.galleryIndex;
      })
    );
  }

  isMobile(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.md);
  }

  openImage(image: ImageGroup): void {
    this.mainContainer.next(image);
    if (typeof image.zoom?.galleryIndex === 'number') {
      this.productImage.emit({ image, index: image.zoom.galleryIndex });
    }
  }

  isActive(thumbnail: ImageGroup): Observable<boolean> {
    return this.mainContainer.asObservable().pipe(
      filter(isNotNullable),
      map((container: ImageGroup) => {
        return (container.zoom?.url &&
          thumbnail.zoom?.url &&
          container.zoom.url === thumbnail.zoom.url) as boolean;
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
